import { MutableRef, useEffect } from 'preact/hooks';

export const useSentinelIntersection = ({
  onIntersection,
  rootRef,
  rootMargin,
  sentinelRef,
}: {
  onIntersection?: () => void;
  rootRef?: MutableRef<any>;
  rootMargin?: string;
  sentinelRef: MutableRef<any>;
}) => {
  useEffect(() => {
    if (!onIntersection) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting) {
          onIntersection();
        }
      },
      {
        root: rootRef?.current,
        rootMargin,
      }
    );

    observer.observe(sentinelRef.current);

    return () => observer.disconnect();
  }, [onIntersection, rootMargin]);
};
